const ENV_CONSTANTS = {
  RESET_PASSWORD_BASE_LINK: 'https://www.iccsafe.org/adoptions/admin/resetpassword',
  GOOGLE_API_GEO_ENDPOINT: 'https://maps.googleapis.com/maps/api/geocode/json?',
  GEO_LOCATION_KEY: 'AIzaSyCwVV0Ooo2-fhKbP25J5w7r0bIiko9aXGQ',
  POLYLIGON_API_URL: 'https://nominatim.openstreetmap.org/',
  POLYLIGON_API_EMAIL_ADDRESSL: 'nikhilv.kakde@infobeans.com',
  MAXCSVFILESIZE: 10000, // Kilo bytes
  APP_ENV: 'PROD', // possible value will DEV || QA || STAGE || PROD
  GA_TRACK_ID_BY_ENV: { 'DEV': 'UA-169211232-1', 'QA': 'UA-169211232-2', 'STAGE': 'UA-4039949-35', 'PROD': 'UA-4039949-36' },
  INTERNAL_API_BASE_ENDPOINT: 'https://adoptions-api.iccsafe.org/'
}

export default ENV_CONSTANTS
